/*  ========================================================================
    # Components - Date Input
    ========================================================================  */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import useLocalization from '../../hooks/useLocalization';
// eslint-disable-next-line import/no-unresolved
import { de } from 'date-fns/locale/de';
import useTranslation from '../../hooks/useTranslation';

registerLocale('de', de);

// eslint-disable-next-line react/prop-types
const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
  <button className='c-date-input__input' onClick={onClick} ref={ref}>
    {value || '–'}
  </button>
));
CustomDateInput.displayName = 'CustomDateInput';

const DateInput = ({
  currentValue,
  onValueChanged,
  min,
  max,
  label,
  name,
  startDate,
  endDate,
  selects,
  locale
}) => {
  const local = useLocalization();
  const __ = useTranslation();
  return (
    <div className='c-date-input'>
      <label htmlFor={`date-input-${name}`} className='c-date-input__label'>
        <svg viewBox='0 0 20 20' title={__('date')}>
          <use title={__('date')} href={`${local('svgSprite')}#calendar`} />
        </svg>
        <span>{label}</span>
      </label>
      <div className='c-date-input__fieldset'>
        <DatePicker
          selected={currentValue}
          onChange={onValueChanged}
          minDate={min}
          maxDate={max}
          dateFormat='dd. MMMM yyyy'
          calendarStartDay={1}
          locale={locale}
          selectsStart={selects === 'arrival'}
          selectsEnd={selects === 'departure'}
          startDate={startDate}
          endDate={endDate}
          withPortal
          customInput={<CustomDateInput />}
        />
      </div>
    </div>
  );
};

DateInput.propTypes = {
  currentValue: PropTypes.instanceOf(Date),
  onValueChanged: PropTypes.func.isRequired,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  locale: PropTypes.string,
  // For date range visualization
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  selects: PropTypes.oneOf(['arrival', 'departure'])
};

export default DateInput;
